import {
  POST_PAYMENT_ALIBABA_LOADING,
  POST_PAYMENT_ALIBABA_DONE,
  POST_PAYMENT_ALIBABA_ERROR,

  FETCH_PACKAGE_MEMBERSHIP_LOADING,
  FETCH_PACKAGE_MEMBERSHIP_DONE,
  FETCH_PACKAGE_MEMBERSHIP_ERROR,

  FETCH_PACKAGE_DESIGNSHOP_LOADING,
  FETCH_PACKAGE_DESIGNSHOP_DONE,
  FETCH_PACKAGE_DESIGNSHOP_ERROR,

  FETCH_PACKAGE_PRODUCT_UPLOAD_LOADING,
  FETCH_PACKAGE_PRODUCT_UPLOAD_DONE,
  FETCH_PACKAGE_PRODUCT_UPLOAD_ERROR,

  FETCH_PACKAGE_ADDITIONAL_LOADING,
  FETCH_PACKAGE_ADDITIONAL_DONE,
  FETCH_PACKAGE_ADDITIONAL_ERROR,

  POST_CHECKING_PROMO_LOADING,
  POST_CHECKING_PROMO_DONE,
  POST_CHECKING_PROMO_ERROR
} from './actions'

export default {
  [POST_PAYMENT_ALIBABA_LOADING] (state) {
    state.isLoadingPostPayment = true
  },
  [POST_PAYMENT_ALIBABA_DONE] (state, items) {
    state.postPayment = items
    state.isLoadingPostPayment = false
  },
  [POST_PAYMENT_ALIBABA_ERROR] (state, error) {
    state.errorPostPayment = error
    state.isLoadingPostPayment = false
  },

  [FETCH_PACKAGE_MEMBERSHIP_LOADING] (state) {
    state.isLoadingPckgMembership = true
  },
  [FETCH_PACKAGE_MEMBERSHIP_DONE] (state, items) {
    state.listPckgMembership = items
    state.isLoadingPckgMembership = false
    state.errorPckgMembership = false
  },
  [FETCH_PACKAGE_MEMBERSHIP_ERROR] (state, error) {
    state.errorPckgMembership = error
    state.isLoadingPckgMembership = false
  },

  [FETCH_PACKAGE_DESIGNSHOP_LOADING] (state) {
    state.isLoadingPckgDesignShop = true
  },
  [FETCH_PACKAGE_DESIGNSHOP_DONE] (state, items) {
    state.listPckgDesignShop = items
    state.isLoadingPckgDesignShop = false
    state.errorPckgDesignShop = false
  },
  [FETCH_PACKAGE_DESIGNSHOP_ERROR] (state, error) {
    state.errorPckgDesignShop = error
    state.isLoadingPckgDesignShop = false
  },

  [FETCH_PACKAGE_PRODUCT_UPLOAD_LOADING] (state) {
    state.isLoadingPckgProduct = true
  },
  [FETCH_PACKAGE_PRODUCT_UPLOAD_DONE] (state, items) {
    state.listPckgProduct = items
    state.isLoadingPckgProduct = false
    state.errorPckgProduct = false
  },
  [FETCH_PACKAGE_PRODUCT_UPLOAD_ERROR] (state, error) {
    state.errorPckgProduct = error
    state.isLoadingPckgProduct = false
  },

  [FETCH_PACKAGE_ADDITIONAL_LOADING] (state) {
    state.isLoadingPckgAdditional = true
  },
  [FETCH_PACKAGE_ADDITIONAL_DONE] (state, items) {
    state.listPckgAdditional = items
    state.isLoadingPckgAdditional = false
    state.errorPckgAdditional = false
  },
  [FETCH_PACKAGE_ADDITIONAL_ERROR] (state, error) {
    state.errorPckgAdditional = error
    state.isLoadingPckgAdditional = false
  },

  [POST_CHECKING_PROMO_LOADING] (state) {
    state.isLoadingCekPromo = true
  },
  [POST_CHECKING_PROMO_DONE] (state, items) {
    state.postCekPromo = items
    state.isLoadingCekPromo = false
    state.errorCekPromo = false
  },
  [POST_CHECKING_PROMO_ERROR] (state, error) {
    state.errorCekPromo = error
    state.isLoadingCekPromo = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/alibabaPayment/mutations.js